document.addEventListener("DOMContentLoaded", () => {
  const descriptionBlock = document.querySelector(
    ".product-single__meta .product-block at-rte.show-short .hide-overflow-wrap"
  );
  const showMoreBtn = document.getElementById("product-description-toggle-btn");
  if (descriptionBlock && descriptionBlock.scrollHeight < 90 && showMoreBtn) {
    showMoreBtn.style.display = "none";
  }
  if (showMoreBtn) {
    showMoreBtn.addEventListener("click", toggleDescriptionLength);
  }
});
function toggleDescriptionLength(e) {
  const descriptionBlock = document.querySelector(
    ".product-single__meta .product-block at-rte"
  );
  if (descriptionBlock) {
    descriptionBlock.classList.toggle("show-short");
    if (descriptionBlock.classList.contains("show-short")) {
      e.target.textContent = e.target.dataset.moreText;
    } else {
      e.target.textContent = e.target.dataset.lessText;
    }
  }
}
